import React from "react";
import PageTop from "../components/PageTop";
import ComplexCard from "../components/ComplexCard";
import founderone from "../Img/foundres/Spn.webp";
import foundertwo from "../Img/foundres/Apn.webp";
import founderthree from "../Img/foundres/contact.webp";
import aboutimg from "../Img/pt-ab.webp";
const Founders = ({ data }) => {
  return (
    <>
      {data.map((data, index) => {
        return (
          <>
            <PageTop
              text={data.Founders}
              url={aboutimg}
              bgPostiion="top center"
            />
            <div className="founder parent">
              <div className="founder-container container-small">
                <h2>
                  {data.AP_founder}
                  <span>{data.AP_founder_span}</span>
                </h2>
                <div className="founder-cards">
                  <ComplexCard
                    url={founderone}
                    title={data.AP_of_box1_title}
                    desc={data.AP_of_box1_desc}
                    btntext={data.AP_btn_box}
                    href="https://sambhajipatilnilangekar.com"
                  />
                  <ComplexCard
                    url={foundertwo}
                    title={data.AP_of_box2_title}
                    desc={data.AP_of_box2_desc}
                    btntext={data.AP_btn_box}
                    href="https://arvindpatilnilangekar.com"
                  />
                  <ComplexCard
                    url={founderthree}
                    title={data.AP_of_box3_title}
                    desc={data.AP_of_box3_desc}
                    btntext={data.AP_btn_box}
                    href="https://prajaktamarwaha.com"
                  />
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
};

export default Founders;
